import React, { useState } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import { trackUxEvent } from 'util/tracking';
import { EVENT_CATEGORIES, PRODUCT_AREAS } from 'util/tracking_constants';

const Section = ({
  autoExpand,
  bottomBorder,
  bottomPadding,
  className = null,
  collapsedContent,
  expandedContent,
  iconName,
  title,
  trackingAction,
}) => {
  const [expanded, setExpanded] = useState(autoExpand);

  function handleTrackArrowClicked() {
    trackUxEvent({
      productArea: PRODUCT_AREAS.TIMESHEETS,
      eventCategory: EVENT_CATEGORIES.TIMECARD_DETAIL,
      eventAction: trackingAction,
    });
  }

  return (
    <Box
      row
      vtop
      mh={24}
      pt={16}
      className={className + ' TimecardModal__Section'}
    >
      <Box minh={28} minw={24} mr={16} overflow="hidden" vcenter>
        {iconName && <Icon iconName={iconName} color="mono500" size="medium" />}
      </Box>
      <Box
        w="calc(100% - 48px)"
        bbw={bottomBorder ? 1 : 0}
        bcolor="mono400"
        pb={bottomPadding ? 16 : 0}
      >
        {title && (
          <Box
            row
            spacebetween
            pointer={!!expandedContent}
            onClick={expandedContent ? partial(setExpanded, !expanded) : null}
            className="Section__TitleWrapper"
          >
            <Text color="mono900" textAlign="left" variant="heading4">
              {title}
            </Text>

            {expandedContent && (
              <Icon
                className={expanded ? 'ChevronUp' : 'ChevronDown'}
                onClick={trackingAction && handleTrackArrowClicked}
                iconName={expanded ? 'ChevronUp' : 'ChevronDown'}
                size="small"
                color="mono700"
                minh={28}
              />
            )}
          </Box>
        )}

        <Text variant="body" color="mono900">
          {expanded ? expandedContent : collapsedContent}
        </Text>
      </Box>
    </Box>
  );
};

Section.propTypes = {
  autoExpand: PropTypes.bool,
  collapsedContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  expandedContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconName: PropTypes.string,
  title: PropTypes.string,
  trackingAction: PropTypes.string,
};

export default Section;
